
async function loadTextsFromJson(id) {
    console.log('🔍 getting settings for id', id)
    const response = await fetch('th-diktat-temp-sheets-settings.json');       
    const settingsJSON = await response.json();
    

    settingsJSON.forEach(element => {
        if (element.dictationID == id) {
            currentSettings = element;
            console.log('CURRENT SETTINGS', currentSettings )
            
        }

    });


    texts = currentSettings.text;
    audiofile = currentSettings.audiofile;
    product = currentSettings.product;
    productImage = currentSettings.productImage;
    productText = currentSettings.productText;
    debugText = currentSettings.debugText;

    addAudioPlayer(audiofile);
    addTextField(debugText);

}

